import { getStatusByFields } from "helpers/bid";
import Tooltip from "rc-tooltip";
import React from "react";

const BidHead = ({ data, id, back, modal, refresh }) => {
    const { externalId, expressBid, isPreBid, hasHiredCar, shippingOrder } = data;
    return (
        <div className="show-bid__head">
            <div className="show-bid__head-close close close--sm" onClick={back} />
            <div className="show-bid__head-title">
                Заказ №{id}&nbsp;
                {!!expressBid && (
                    <Tooltip overlayClassName="show-bid__head--tooltip" overlay="Экспресс-заявка" placement="bottom">
                        <small className="pl-1 icon-uEA90-bolt b-point__tooltip-icon" />
                    </Tooltip>
                )}
                {hasHiredCar && (
                    <Tooltip placement="right" overlayClassName="notifys__tooltip" overlay="Наемный ТС">
                        <i className="icon-uEAD4-hired-car b-table__compound-icon pl-1" />
                    </Tooltip>
                )}
                {shippingOrder && <span className="badge badge-info ml-1">ЭЗЗ</span>}
                &nbsp;
                {externalId && <small className="text-muted">({externalId})</small>}
            </div>
            <div className="show-bid__head-status">
                {getStatusByFields(data, { modal, onInProcessReset: refresh })}
                {isPreBid && <span className="badge badge-secondary">Предзаявка</span>}
            </div>
        </div>
    );
};

export default BidHead;
